<template>
  <svg
    :width="size"
    :height="size"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    viewBox="0 0 24 24"
  >
    <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
    <polyline points="10 17 15 12 10 7" />
    <line
      x1="15"
      y1="12"
      x2="3"
      y2="12"
    />
  </svg>
</template>

<script>
export default {
  name: "LoginIcon",
  props: {
    size: { type: Number, default: 14 },
  },
};
</script>
